import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

// Android bridge method - called externally to save OneSignal ID 
window.setValueFromAndroid = function (value) {
  localStorage.setItem("oneSignalId", value);
};

function Splash() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  useEffect(() => {
    const savedId = localStorage.getItem("oneSignalId");

    if (savedId) {
      handleLogin(savedId);
      return;
    }

    // Give Android a chance to provide the ID
    const retryTimeout = setTimeout(() => {
      const retryId = localStorage.getItem("oneSignalId");

      if (retryId) {
        handleLogin(retryId);
      } else {
        navigate("/login");
      }
    }, 2000);

    return () => clearTimeout(retryTimeout);

    async function handleLogin(oneSignalId) {
      try {
        console.log("Checking OneSignal ID:", oneSignalId);

        const response = await axios.post(
          `${API_URL}/check-onesignal-id`,
          { oneSignalId },
          { withCredentials: true }
        );

        console.log("Login response:", response.data);

        if (response.data.status === "exists") {
          localStorage.setItem("user_id", response.data.user_id);

          navigate(response.data.redirect || "/home", {
            replace: true,
          });
        } else {
          navigate("/login", {
            replace: true,
          });
        }
      } catch (error) {
        console.error("OneSignal login failed:", error);
        navigate("/login", {
          replace: true,
        });
      }
    }
  }, [navigate]);

   

  return (
    <div className="bg_light_greenx" style={{ background: '#000' }}>
      <div id="page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="page-content header-clear-small pb-0" style={{ overflow: 'hidden' }}>
          <img
            src="img/oret_load.png"
            alt="Splash loading"
            style={{ height: '400px', width: '100%', objectFit: 'cover' }}
          />
        </div>
      </div>
    </div>
  );
}

export default Splash;
